import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Pipe({name: "safe"})
export class SafeUrlPipe implements PipeTransform
{

	/**
	 * Function > constructor
	 * @param sanitizer
	 */
	constructor(private sanitizer: DomSanitizer)
	{
	} // end function constructor

	/**
	 * Function > transform
	 * @param STR_url
	 * @return {SafeResourceUrl}
	 */
	transform(STR_url): SafeResourceUrl
	{
		return this.sanitizer.bypassSecurityTrustResourceUrl(STR_url);
	} // end function transform

} // end class SafeUrlPipe